import React, { FC, useState } from "react"
import { Box, Flex, FlexProps, Heading, Text } from "@chakra-ui/react"
import { StarIcon } from "./Icons"

export type ReviewItemType = {
  title: string
  date: string
  author: string
  text: string
}

export const ReviewsList: FC<{ list: ReviewItemType[] } & FlexProps> = ({ list, ...props }) => (
  <Flex direction="row" gap={2} minH="185px" overflowX="auto" overflowY="hidden" {...props}>
    {list.map((review, i) => (
      <ReviewItem {...review} key={i} />
    ))}
  </Flex>
)

/* TODO move to shared */
/* same as packages/paywall-react/src/pages/Main/ReviewsBetterMe/ReviewsBetterMe.tsx */
export const ReviewItem: FC<ReviewItemType> = ({ title, date, author, text }) => {
  const [collapsed, setCollapsed] = useState(true)
  const handleShowMoreClick = () => setCollapsed(false)

  return (
    <Flex direction="column" p={4} borderRadius="2xl" bgColor="#F2F1F7" minW="295px">
      <Flex w="full" justifyContent="space-between">
        <Heading as="h5" variant="text" size="Subtitle/Secondary">
          {title}
        </Heading>
        <Box textStyle="Paragraph/Secondary" textColor="Base/baseSecondary">
          {date}
        </Box>
      </Flex>
      <Flex w="full" justifyContent="space-between" alignItems="center" mb={3}>
        <Flex flexWrap="nowrap">
          <StarIcon fontSize={16} />
          <StarIcon fontSize={16} />
          <StarIcon fontSize={16} />
          <StarIcon fontSize={16} />
          <StarIcon fontSize={16} />
        </Flex>
        <Box textStyle="Paragraph/Secondary" textColor="Base/baseSecondary">
          {author}
        </Box>
      </Flex>
      <Box pos="relative">
        <Text textStyle="RegularParagraphSecondary" noOfLines={collapsed ? 5 : undefined}>
          {text}
        </Text>
        {collapsed && (
          <Box
            m={-1}
            p={1}
            onClick={handleShowMoreClick}
            cursor="pointer"
            as="span"
            pos="absolute"
            right={0}
            bottom={0}
            textStyle="MediumSubtitleTertiary"
            textColor="Base/accentPrimary"
          >
            <Box
              h="full"
              w="calc(100% + 33px)"
              background="linear-gradient(270deg, #F2F1F7 73.19%, rgba(242, 241, 247, 0) 100%);"
              pos="absolute"
              right={0}
              bottom={0}
            />
            <Box pos="relative">See more</Box>
          </Box>
        )}
      </Box>
    </Flex>
  )
}
